import React from "react";
import clsx from "clsx";

export function Card({ children, className }) {
  return (
    <div
      className={clsx(
        "bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300",
        "p-6",
        className
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, className }) {
  return (
    <div className={clsx("mb-4", className)}>
      {title && (
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
      )}
      {subtitle && (
        <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
      )}
    </div>
  );
}

export function CardContent({ children, className }) {
  return (
    <div className={clsx("text-gray-700", className)}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className }) {
  return (
    <div
      className={clsx(
        "mt-6 pt-4 border-t border-gray-200 flex items-center justify-end gap-2",
        className
      )}
    >
      {children}
    </div>
  );
}
